import { TemaCard } from "../models/TemaCardModel";

export const emergencyCards: TemaCard[] = [
    // ☎️ Emergencies Contact Numbers
    new TemaCard(
        'emergency1',
        'Emergencies',
        'word',
        'número de emergencias',
        'emergency number',
        'Know who to call in different countries.',
        [
            { spanish: '112 (UE)', english: '112 (EU)' },
            { spanish: '911 (EE.UU.)', english: '911 (US)' },
            { spanish: '061 (España - urgencias médicas)', english: '061 (Spain - medical emergencies)' },
        ]
    ),
    new TemaCard(
        'emergency2',
        'Emergencies',
        'sentence',
        'Llame al 112, por favor. Es una emergencia.',
        'Call 112, please. It’s an emergency.',
        'Use if you can’t call yourself.'
    ),

    // 🧭 Types of Emergencies (Categories)
    new TemaCard(
        'emergencyTypes',
        'Emergencies',
        'word',
        'emergencia',
        'emergency',
        'Used for general situations.',
        [
            { spanish: 'emergencia médica', english: 'medical emergency' },
            { spanish: 'accidente', english: 'accident' },
            { spanish: 'incendio', english: 'fire' },
            { spanish: 'desastre natural', english: 'natural disaster' },
            { spanish: 'emergencia policial', english: 'police emergency' }
        ]
    ),

    // 🚑 Medical Emergencies
    new TemaCard(
        'emergency3',
        'Emergencies',
        'sentence',
        '¡Necesito ayuda médica urgente!',
        'I need urgent medical help!',
        'Say this when you or someone else is seriously ill.'
    ),
    new TemaCard(
        'emergency4',
        'Emergencies',
        'phrase',
        'Llame a una ambulancia, por favor.',
        'Call an ambulance, please.',
        'Use if someone faints, is unresponsive, or in serious pain.'
    ),
    new TemaCard(
        'emergency5',
        'Emergencies',
        'sentence',
        'Hay una persona inconsciente.',
        'There’s an unconscious person.',
        'Describe the emergency clearly.'
    ),

    // 🚗 Accidents
    new TemaCard(
        'emergency6',
        'Emergencies',
        'sentence',
        'Hubo un accidente de coche.',
        'There was a car accident.',
        'Use in traffic situations.'
    ),
    new TemaCard(
        'emergency7',
        'Emergencies',
        'sentence',
        'Alguien está sangrando mucho.',
        'Someone is bleeding heavily.',
        'Let first responders know the severity.'
    ),

    // 🌪 Natural Disasters
    new TemaCard(
        'emergency8',
        'Emergencies',
        'sentence',
        'Hay un terremoto/incendio/inundación.',
        'There’s an earthquake/fire/flood.',
        'Use depending on the situation.'
    ),
    new TemaCard(
        'emergency9',
        'Emergencies',
        'phrase',
        'Necesitamos salir del edificio.',
        'We need to leave the building.',
        'For evacuation situations.'
    ),

    // 🤒 Symptoms (for you or others)
    new TemaCard(
        'emergency11',
        'Emergencies',
        'sentence',
        'Tengo dificultad para respirar.',
        'I’m having trouble breathing.',
        'Use if you’re short of breath.'
    ),
    new TemaCard(
        'emergency12',
        'Emergencies',
        'phrase',
        'Me siento mareado.',
        'I feel dizzy.',
        'Can be a sign of many issues — say it early.'
    ),

    // 🧾 Critical Info for Medical Staff
    new TemaCard(
        'emergency13',
        'Emergencies',
        'sentence',
        'Soy alérgico a la penicilina.',
        'I’m allergic to penicillin.',
        'Share this if you know your allergies.'
    ),

    new TemaCard(
        'emergency16',
        'Emergencies',
        'sentence',
        'Alguien me ha quitado la cartera/el bolso.',
        'Someone took my wallet/bag.',
        'Helpful when reporting a theft to the police or others.'
    ),
    new TemaCard(
        'emergency17',
        'Emergencies',
        'phrase',
        '¿Dónde está la comisaría de policía más cercana?',
        'Where is the nearest police station?',
        'For reporting the incident in person.'
    ),
    new TemaCard(
        'emergency18',
        'Emergencies',
        'sentence',
        'Quiero denunciar un robo.',
        'I want to report a robbery.',
        'Use this phrase at a police station or consulate.'
    ),
];
